import type { Release } from "@packages/commons";

import { global } from "@/global";
import type { ResourceCollection } from "./types";

export const releaseCollection = <T extends { id?: string }>(
  name: string,
  releaseKey: "connections" | "mapping",
  valid: (resource: T) => boolean,
): ResourceCollection => ({
  scopeId: ({ releaseId }) => releaseId,
  load: async (releaseId) => {
    const response = await global.dataProvider.getList(name, {
      parent: { resource: "releases", id: releaseId },
    });
    return response.data;
  },
  merge: (release, live, ownedIds) => {
    const embedded = (release[releaseKey] ?? []) as unknown as T[];
    const current = (live as T[]).filter(valid);
    const liveIds = new Set(current.map((resource) => resource.id));
    return {
      ...release,
      [releaseKey]: [
        ...current,
        ...embedded.filter((resource) => resource.id && ownedIds.has(resource.id) && !liveIds.has(resource.id)),
      ],
    } as Release;
  },
});
